<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <!-- image -->
        <b-img
          fluid
          :src="downImg"
          alt="Error page"
        />

        <h2 class="mb-1 text-main">
          Page Not Found
        </h2>

        <p>The requested URL was not found on this project.</p>

        <div class="mt-3">
          <b-button
            v-if="showRefresh"
            variant="bg-white"
            class="mb-2 mr-1 btn-sm-block"
            @click="refresh()"
          >
            Refresh Page
          </b-button>

          <b-button
            variant="primary"
            class="mb-2 btn-sm-block"
            :to="{ path: '/' }"
          >
            Return to Homepage
          </b-button>
        </div>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BButton, BImg } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BImg,
  },
  props: {
    showRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error-404.svg'),
    }
  },
  methods: {
    refresh() {
      this.$store.commit('app/UPDATE_KEY')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
